'use client';

/**
 * No-UI mount for the first-touch attribution capture.
 *
 * Renders nothing; runs `captureAttributionFromUrl()` once on mount via
 * useEffect. Mounted globally in `src/app/layout.tsx` so direct landings
 * on any public page (/, /start, /home, /pricing, /weight-loss, etc.)
 * capture cleanly without per-page wiring.
 *
 * Auth-gated routes also mount this — that's fine. The hook short-circuits
 * if the cookie already exists, so authenticated visits to /dashboard are
 * a no-op after the first touch landed.
 */

import { useEffect } from 'react';
import { captureAttributionFromUrl } from './capture-attribution';

export function AttributionCapture() {
  useEffect(() => {
    captureAttributionFromUrl();
  }, []);
  return null;
}
